import { deviceClass } from '@kerfjs/ui/device-class';
import { wireNavStack } from '@kerfjs/ui/wire-nav-stack';
import { effect } from 'kerfjs';

import { lineEvidenceDetailActive, lineEvidenceDialog } from '../data/state.js';
/** Wire the evidence split's compact NavStack (back control, push/pop motion,
 * focus) whenever the dialog is open on a compact device. `wireNavStack` binds
 * to the rendered stack, so it is re-wired each time a stack appears and
 * disposed when it goes away. `root` is page-lifetime (HS2-AW53XQ). Kept apart
 * from the dialog module so importing it early does not reorder the dialog's CSS. */
export function wireLineEvidence(root: HTMLElement): () => void {
  let disposeStack: (() => void) | undefined;
  let frame = 0;
  const release = (): void => {
    cancelAnimationFrame(frame);
    disposeStack?.();
    disposeStack = undefined;
  };
  const disposeEffect = effect(() => {
    const stacked = lineEvidenceDialog.value !== null && deviceClass().value.compact;
    release();
    if (!stacked) return;
    // Wire after the mount has rendered the NavStack for this state.
    frame = requestAnimationFrame(() => {
      const stack = root.querySelector('#line-evidence-split [data-component="nav-stack"]');
      if (stack === null) return;
      disposeStack = wireNavStack(stack, {
        onBack: () => {
          lineEvidenceDetailActive.value = false;
        },
      });
    });
  });
  return () => {
    disposeEffect();
    release();
  };
}
